import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { StandardButton } from "@/components/standard-button";

export default function YumlabRecipe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["recipe", id],
    queryFn: async () => {
      const r = await fetch(`/api/recipes/${id}`);
      if (!r.ok) throw new Error("Not found");
      return r.json() as Promise<{
        id: number;
        title: string;
        image: string | null;
        servings: number;
        ingredients: Array<{
          id: number;
          name: string;
          qty: string | null;
          unit: string | null;
          notes: string | null;
        }>;
        steps: Array<{ id: number; text: string; idx: number; timer_sec: number | null }>;
      }>;
    },
  });

  if (!data) return null;

  return (
    <div className="min-h-screen bg-background text-ink">
      <div className="mx-auto max-w-3xl px-4 py-8 space-y-6">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <StandardButton
              onClick={() => navigate(`/`)}
              className="bg-mint text-ink hover:bg-mint/90"
            >
              Home
            </StandardButton>
            <h1 className="font-display text-3xl">{data.title}</h1>
          </div>
          <Button
            onClick={() => navigate(`/cook/${data.id}`)}
            className="cartoony-btn rounded-full bg-mango text-ink hover:bg-mango/90"
          >
            Start Cook
          </Button>
        </header>

        <Card className="rounded-2xl">
          <CardHeader>
            <CardTitle className="font-display">Ingredients</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-6 space-y-1">
              {data.ingredients.map((ing) => (
                <li key={ing.id}>{[ing.qty, ing.unit, ing.name].filter(Boolean).join(" ")}</li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="rounded-2xl">
          <CardHeader>
            <CardTitle className="font-display">Steps</CardTitle>
          </CardHeader>
          <CardContent>
            <ol className="list-decimal pl-6 space-y-3">
              {data.steps.map((s) => (
                <li key={s.id} className="leading-relaxed">
                  {s.text}{" "}
                  {s.timer_sec ? (
                    <span className="text-muted-foreground">
                      (
                      {Math.round(s.timer_sec / 60) > 0
                        ? `${Math.round(s.timer_sec / 60)} min`
                        : `${s.timer_sec} sec`}
                      )
                    </span>
                  ) : null}
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
